import { render, staticRenderFns } from "./together.vue?vue&type=template&id=35aee5f3&scoped=true"
import script from "./together.vue?vue&type=script&lang=js"
export * from "./together.vue?vue&type=script&lang=js"
import style0 from "./together.vue?vue&type=style&index=0&id=35aee5f3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35aee5f3",
  null
  
)

export default component.exports